import UserPermissionView from './UserPermissionView.container';

export default UserPermissionView;
